import React, {useState, useRef} from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import { NUMBER } from "../../../constants/app-constants";
import priceFormatter from "../../../utils/helpers/price-formatter";
import { sendCustomGaEvents } from "../../../tracking";
import { viewMoreChallans } from "./tracking";

const THRESHOLD = NUMBER.FOUR;

const EChallanTrafficFines = ({
    stateName = "",
    trafficFines = {},
    isDesktop = false
}) => {

    const { sectionData = [] } = trafficFines || {};

    const isFineListAboveThreshold = sectionData && sectionData?.length > THRESHOLD;
    const sectionRef = useRef(null);
    const [showAllFines, setShowAllFines] = useState(false);
    const filteredFines = isFineListAboveThreshold ? sectionData.slice(0, THRESHOLD) : sectionData;

    const handleClick = () => {
        if (showAllFines) {
            setShowAllFines(false);
            return;
        }
        setShowAllFines(true);
        sendCustomGaEvents(viewMoreChallans);
    };

    const getPrice = (price) => {
        if (isNaN(price)) return price;
        const formattedPrice = priceFormatter(price);
        return `₹${formattedPrice}`;
    };

    const renderList = (list = []) => {
        return (
            <ul styleName={"styles.finesList"}>
                <li styleName={"styles.fineHeader"}>
                    <span>Offence</span>
                    <span>Regular Fine</span>
                    <span>Subsequent</span>
                </li>
                {
                    list.map(({offenceName, firstOffencePenalty, secondOffencePenalty}, index) => (
                        <li key={`offence_${index}`} styleName={"styles.fineText"}>
                            <span>{offenceName}</span>
                            <span>{getPrice(firstOffencePenalty)}</span>
                            <span>{getPrice(secondOffencePenalty)}</span>
                        </li>
                    ))
                }
            </ul>
        );
    };

    if (sectionData && sectionData?.length === NUMBER.ZERO) return null;

    return (
        <div styleName={`styles.finesWrapper ${isDesktop ? "finesWrapperDesktop" : ""}`} ref={sectionRef}>
            <h2>Traffic fines in {stateName}</h2>
            {renderList(showAllFines ? sectionData : filteredFines)}
            <span styleName={"styles.seeAllList"} onClick={handleClick}>
                {showAllFines ? "View Less" : "View More"}
            </span>
        </div>
    );
};

EChallanTrafficFines.propTypes = {
    stateName: PropTypes.string,
    trafficFines: PropTypes.array,
    isDesktop: PropTypes.bool
};

export default EChallanTrafficFines;
